<template>
  <div>
    <JsonEditor v-model="workflowDefinition" />
    <button @click="createWorkflowDefinition(workflowDefinition)">
      Create
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import JsonEditor from '@/components/JsonEditor.vue'

export default {
  name: 'WorkflowDefinitionCreate',
  data() {
    return {
      workflowDefinition: {
        name: null,
        tasks: []
      }
    }
  },
  methods: mapActions(['createWorkflowDefinition']),
  components: {
    JsonEditor
  }
}
</script>
